export default __webpack_public_path__ + "static/media/emi_s.6ede8c32.jpg";